import { useDispatch, useSelector } from "react-redux";
import "../manage.css";
import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {
  removeRegjistriDokHumbura,
  setRegjistriDokHumbura,
  setRegjistriDokHumburaOnEdit,
} from "../../Redux/Actions/regjDokHumburaActions";

const ManageRegjistriDokHumbura = () => {
  const dispatch = useDispatch();
  const [regjistriDokHumbura, setRegjDokHumbura] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const loggedUser = useSelector((state) => state.users.loggedUser);
  const isLoggedIn = Object.keys(loggedUser).length > 0;
  const navigate = useNavigate();

  if (!isLoggedIn) {
    navigate("/login");
  }

  useEffect(() => {
    const fetchRegjistriDokHumbura = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `https://api.arkiva.gov.al/api/regjistriDokHumbura?page=${currentPage}&limit=20`,
        );
        setRegjDokHumbura(response.data.regjDokHumbura);
        setTotalPages(response.data.totalPages);
        dispatch(setRegjistriDokHumbura(response.data.regjDokHumbura));
      } catch (error) {
        console.error(
          "Error fetching regjistri dokumentave te humbura:",
          error,
        );
      }
      setLoading(false);
    };

    if (isLoggedIn) {
      fetchRegjistriDokHumbura();
    } else {
      navigate("/login");
    }
  }, [dispatch, isLoggedIn, navigate, currentPage]);

  const editRegjistriDokHumbura = (regjistriDokHumbura) => {
    navigate(`/manage/regjistriDokHumbura/${regjistriDokHumbura._id}`);
    dispatch(setRegjistriDokHumburaOnEdit(regjistriDokHumbura));
  };

  const addRegjistriDokHumbura = () => {
    navigate("/manage/regjistriDokHumbura/add-new");
  };

  const deleteRegjistriDokHumbura = async (regjistriDokHumbura) => {
    try {
      const response = await axios.delete(
        `https://api.arkiva.gov.al/api/regjistriDokHumbura/delete/${regjistriDokHumbura._id}`,
      );
      if (response.data.message === "error") {
        alert("Something went wrong!");
      } else {
        setRegjDokHumbura((prevRegjistriDokHumbura) =>
          prevRegjistriDokHumbura.filter(
            (item) => item._id !== response.data.regjDokHumburaId,
          ),
        );
        dispatch(removeRegjistriDokHumbura(response.data.regjDokHumburaId));
      }
    } catch (error) {
      console.error("Error deleting regjistri dokumentave te humbura:", error);
    }
  };

  const filteredRegjistriDokHumbura = regjistriDokHumbura.filter((item) =>
    item.fond.toLowerCase().includes(search.toLowerCase()),
  );

  return (
    <div className="manage-page">
      {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
      <div className="manage-page-header">
        <div className="manage-page-header-actions">
          <input
            type="text"
            placeholder="Search"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
          />
          <button onClick={addRegjistriDokHumbura}>
            <i className="fa-solid fa-plus"></i> Shto Dokument të humbur
          </button>
        </div>
      </div>

      <div className="manage-table">
        <table className="table">
          <thead>
            <tr>
              <th>Nr. i fondit</th>
              <th>Fondi</th>
              <th>Data e fletës së vërtetimit</th>
              <th>Data e rigjetjes së dokumentit</th>
              <th>Veprime</th>
            </tr>
          </thead>
          <tbody>
            {filteredRegjistriDokHumbura.length > 0 ? (
              filteredRegjistriDokHumbura.map((item, index) => (
                <tr key={index}>
                  <td data-label="Nr. i fondit">{item.fondNr}</td>
                  <td data-label="Fondi">{item.fond}</td>
                  <td data-label="Data e fletës së vërtetimit">
                    {item.verificationDate}
                  </td>
                  <td data-label="Data e rigjetjes së dokumentit">
                    {item.foundDate}
                  </td>
                  <td className="actions" data-label="Veprime">
                    <button onClick={() => editRegjistriDokHumbura(item)}>
                      <i className="fa-solid fa-pen-to-square"></i>
                    </button>
                    <button onClick={() => deleteRegjistriDokHumbura(item)}>
                      <i className="fa-solid fa-trash"></i>
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5">Nuk u gjetën dokumente të humbura!</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Pagination Controls */}
      <div className="pagination">
        <button
          className={`pagination-control-btn ${
            currentPage === 1 ? "disabled" : ""
          }`}
          disabled={currentPage === 1}
          onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
        >
          &#8592; Para
        </button>

        <span className="pagination-current-page">
          Page {currentPage} of {totalPages}
        </span>

        <button
          className={`pagination-control-btn ${
            currentPage === totalPages ? "disabled" : ""
          }`}
          disabled={currentPage === totalPages}
          onClick={() =>
            setCurrentPage((prev) => Math.min(prev + 1, totalPages))
          }
        >
          Pas &#8594;
        </button>
      </div>
    </div>
  );
};

export default ManageRegjistriDokHumbura;
